import clsx from 'clsx'
import React, { PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'

import Sidebar from '@/components-latest/layout/Sidebar'
import { selectIsSidebarOpen } from '@/ducks/app/selectors/app.selectors'

import Styles from './PrivateLayout.module.scss'

const PrivateLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const isSidebarOpen = useSelector(selectIsSidebarOpen)

  return (
    <div className={Styles.privateLayout} data-testid="private-layout">
      <Sidebar />
      <div
        className={clsx(Styles.content, {
          [Styles.contentExpanded]: !isSidebarOpen
        })}>
        {children}
      </div>
    </div>
  )
}

export default PrivateLayout
